import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Opkrævning fra betalingsmetode',
    [BillingMode.InternalInvoicing]: 'Opkrævning fra salg',
    active: 'Aktiv',
    on_trial: 'I prøveperiode',
    launch_pending: 'På pause indtil lanceringsdato',
    billing_disabled: 'Fakturering deaktiveret',
    on_grace_period: 'I henstandsperiode',
    past_due: 'Forfalden',
    cancelled: 'Opsagt',
  },
};
